type IGaProduct = {
    id: string;
    name: string;
    price: string;
    quantity: number;
}

enum GaProductInteractionStep {
    Choose = 'choose_insurance',
    ContactInformation = 'contact_information',
    Payment = 'payment'
}

const trackProductsInteraction = (name: string, currency: string, products: IGaProduct[]) => {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: name,
        ecommerce: {
            currency: currency,
            checkout: {
                products
            }
        }
    });
};

const trackProductInteraction = (name: string, currency: string, product: IGaProduct) => {
    trackProductsInteraction(name, currency, [product]);
};

(window as any).GaTracking = (window as any).GaTracking || {};

(window as any).GaTracking.trackProducts = (name: string, currency: string, productsJson: string) => {
    trackProductsInteraction(name, currency, JSON.parse(productsJson));
};

(window as any).GaTracking.trackProduct = (name: string, currency: string, productJson: string) => {
    trackProductInteraction(name, currency, JSON.parse(productJson));
};

(window as any).GaTracking.productInteractionSteps = {
    Choose: GaProductInteractionStep.Choose,
    ContactInformation: GaProductInteractionStep.ContactInformation,
    Payment: GaProductInteractionStep.Payment
};